// import React, { useState, useEffect } from 'react';
// import axios from 'axios';
// import { Table, Container, Row, Col, Card } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar';


// const ViewBooking = () => {
//   const [bookings, setBookings] = useState([]);

//   useEffect(() => {
//     // Fetch booking data from the Express backend
//     axios.get('https://posapi.emedha.in/api/api/bookings')
//       .then(response => {
//         setBookings(response.data);
//       })
//       .catch(error => {
//         console.error('There was an error fetching the bookings:', error);
//       });
//   }, []);

//   return (
//     <>
//     <Sidebar/>
//     <div id='main'>
//     <div className="content-wrapper">
//       <section className="content-header">
//         <h1>View Bookings</h1>
//         <hr />
//       </section>

//       <section className="content container-fluid">
//         <Card className="box box-success">
//           <Card.Header>
//             <h3 className="box-title">View Booking Details</h3>
//           </Card.Header>

//           <Card.Body>
//             <Container fluid>
//               <Row>
//                 <Col>
//                   <Table responsive striped bordered hover>
//                     <thead>
//                       <tr>
//                         <th>S.No</th>
//                         <th>Mobile Number</th>
//                         <th>Customer Name</th>
//                         <th>Gothram</th>
//                         <th>Amount</th>
//                         <th>Pooja Name</th>
//                         <th>Pooja Date</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {bookings.map((row, index) => (
//                         <tr key={row.sno}>
//                           <td>{index + 1}</td>
//                           <td>{row.mobileNumber}</td>
//                           <td>{row.customerName}</td>
//                           <td>{row.gothram}</td>
//                           <td>{row.amount}</td>
//                           <td>{row.pid}</td>
//                           <td>{row.poojadate}</td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                 </Col>
//               </Row>
//             </Container>
//           </Card.Body>
//         </Card>
//       </section>
//     </div>
//     </div>
//     </>
//   );
// }

// export default ViewBooking;



// import React, { useState, useEffect } from 'react';
// import { Table, Container, Row, Col, Card, Pagination, Dropdown, ButtonGroup } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar';
// import axios from 'axios';

// const ViewBooking = () => {
//   const [bookings, setBookings] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);

// //   useEffect(() => {
// //     // Simulate fetching booking data (replace this with your actual data fetching)
// //     const fetchData = async () => {
// //       // For now, assuming `bookings` contains an array of 100+ records.
// //       const dummyBookings = Array.from({ length: 100 }, (_, index) => ({
// //         sno: index + 1,
// //         mobileNumber: '1234567890',
// //         customerName: `Customer ${index + 1}`,
// //         gothram: 'GothramName',
// //         amount: Math.floor(Math.random() * 1000) + 1,
// //         pid: `Pooja-${index + 1}`,
// //         poojadate: `2025-01-${index + 1}`,
// //       }));
// //       setBookings(dummyBookings);
// //     };
    
// //     fetchData();
// //   }, []);

// useEffect(() => {
//     // Fetch booking data from the Express backend
//     axios.get('https://posapi.emedha.in/api/api/bookings')
//       .then(response => {
//         setBookings(response.data);
//       })
//       .catch(error => {
//         console.error('There was an error fetching the bookings:', error);
//       });
//   }, []);

//   // Handle page size change (10, 20, 30 records per page)
//   const handlePageSizeChange = (newSize) => {
//     setPageSize(newSize);
//     setCurrentPage(1);  // Reset to the first page when page size changes
//   };

//   // Calculate the index range for current page
//   const indexOfLastBooking = currentPage * pageSize;
//   const indexOfFirstBooking = indexOfLastBooking - pageSize;
//   const currentBookings = bookings.slice(indexOfFirstBooking, indexOfLastBooking);

//   // Pagination logic
//   const totalPages = Math.ceil(bookings.length / pageSize);
//   const pageNumbers = [];
//   for (let i = 1; i <= totalPages; i++) {
//     pageNumbers.push(i);
//   }

//   // Handle page change
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   return (
//     <>
//       <Sidebar />
//       <div id="main">
//         <div className="content-wrapper">
//           <section className="content-header">
//             <h1>View Bookings</h1>
//             <hr />
//           </section>

//           <section >
          
            

//               <Card.Body>
//                 <Container >
//                   <Row>
//                     <Col className="d-flex justify-content-end align-items-center">
//                       {/* Dropdown Button for "Show Entries" */}
//                       <Dropdown as={ButtonGroup}>
//                         <ButtonGroup>
//                           <Dropdown.Toggle variant="secondary" size="sm">
//                             Show Entries
//                           </Dropdown.Toggle>
//                           <Dropdown.Menu>
//                             <Dropdown.Item onClick={() => handlePageSizeChange(5)}>5</Dropdown.Item>
//                             <Dropdown.Item onClick={() => handlePageSizeChange(10)}>10</Dropdown.Item>
//                             <Dropdown.Item onClick={() => handlePageSizeChange(20)}>20</Dropdown.Item>
//                             <Dropdown.Item onClick={() => handlePageSizeChange(30)}>30</Dropdown.Item>
//                             <Dropdown.Item onClick={() => handlePageSizeChange(40)}>40</Dropdown.Item>
//                           </Dropdown.Menu>
//                         </ButtonGroup>
//                       </Dropdown>
//                     </Col>
//                   </Row>

//                   {/* Booking Table */}
//                   <Row>
//                     <Col>
//                       <Table responsive striped bordered hover>
//                         <thead>
//                           <tr>
//                             <th>S.No</th>
//                             <th>Mobile Number</th>
//                             <th>Customer Name</th>
//                             <th>Gothram</th>
//                             <th>Amount</th>
//                             <th>Pooja Name</th>
//                             <th>Pooja Date</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {currentBookings.map((row, index) => (
//                             <tr key={row.sno}>
//                               <td>{indexOfFirstBooking + (index + 1)}</td>
//                               <td>{row.mobileNumber}</td>
//                               <td>{row.customerName}</td>
//                               <td>{row.gothram}</td>
//                               <td>{row.amount}</td>
//                               <td>{row.pid}</td>
//                               <td>{row.poojadate}</td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </Table>

//                       {/* Pagination */}
//                       <Pagination>
//                         <Pagination.Prev
//                           onClick={() => handlePageChange(currentPage - 1)}
//                           disabled={currentPage === 1}
//                         />
//                         {pageNumbers.map(number => (
//                           <Pagination.Item
//                             key={number}
//                             active={number === currentPage}
//                             onClick={() => handlePageChange(number)}
//                           >
//                             {number}
//                           </Pagination.Item>
//                         ))}
//                         <Pagination.Next
//                           onClick={() => handlePageChange(currentPage + 1)}
//                           disabled={currentPage === totalPages}
//                         />
//                       </Pagination>
//                     </Col>
//                   </Row>
//                 </Container>
//               </Card.Body>
          
//           </section>
//         </div>
//       </div>
//     </>
//   );
// }

// export default ViewBooking;




// import React, { useState, useEffect } from 'react';
// import { Table, Container, Row, Col, Card, Pagination, Dropdown, ButtonGroup } from 'react-bootstrap';
// import Sidebar from '../Sidebar/Sidebar';
// import axios from 'axios';

// const ViewBooking = () => {
//   const [bookings, setBookings] = useState([]);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [pageSize, setPageSize] = useState(10);

//   useEffect(() => {
//     // Fetch booking data from the Express backend
//     axios.get('https://posapi.emedha.in/api/api/bookings')
//       .then(response => {
//         setBookings(response.data);
//       })
//       .catch(error => {
//         console.error('There was an error fetching the bookings:', error);
//       });
//   }, []);

//   // Handle page size change (10, 20, 30 records per page)
//   const handlePageSizeChange = (newSize) => {
//     setPageSize(newSize);
//     setCurrentPage(1);  // Reset to the first page when page size changes
//   };

//   // Calculate the index range for current page
//   const indexOfLastBooking = currentPage * pageSize;
//   const indexOfFirstBooking = indexOfLastBooking - pageSize;
//   const currentBookings = bookings.slice(indexOfFirstBooking, indexOfLastBooking);

//   // Pagination logic
//   const totalPages = Math.ceil(bookings.length / pageSize);
//   const pageNumbers = [];
//   for (let i = 1; i <= totalPages; i++) {
//     pageNumbers.push(i);
//   }

//   // Group the pages into batches and add ellipsis if necessary
//   const getPaginationGroup = () => {
//     const pageGroupSize = 5;
//     let start = Math.floor((currentPage - 1) / pageGroupSize) * pageGroupSize;
//     let end = start + pageGroupSize;

//     if (end >= totalPages) {
//       end = totalPages;
//     }

//     return pageNumbers.slice(start, end);
//   };

//   // Handle page change
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };
//   // Format date as YYYY-MM-DD
//   const formatDate = (dateString) => {
//     const date = new Date(dateString); // Create Date object
//     const year = date.getFullYear();
//     const month = String(date.getMonth() + 1).padStart(2, '0'); // Format month (01-12)
//     const day = String(date.getDate()).padStart(2, '0'); // Format day (01-31)
//     return `${year}-${month}-${day}`; // Return as YYYY-MM-DD
//   };
//   return (
//     <>
//       <Sidebar />
//       <div id="main">
//         <div className="content-wrapper">
//           <section className="content-header">
//             <h1>View Bookings</h1>
//             <hr />
//           </section>

//           <section className="content container-fluid">
          

//               <Card.Body>
//                 <Container fluid>
//                   <Row>
//                     <Col className="d-flex justify-content-end align-items-center">
//                       {/* Dropdown Button for "Show Entries" */}
//                       <Dropdown as={ButtonGroup}>
//                         <ButtonGroup>
//                           <Dropdown.Toggle variant="secondary" size="sm">
//                             Show Entries
//                           </Dropdown.Toggle>
//                           <Dropdown.Menu>
//                             <Dropdown.Item onClick={() => handlePageSizeChange(10)}>10</Dropdown.Item>
//                             <Dropdown.Item onClick={() => handlePageSizeChange(20)}>20</Dropdown.Item>
//                             <Dropdown.Item onClick={() => handlePageSizeChange(30)}>30</Dropdown.Item>
//                           </Dropdown.Menu>
//                         </ButtonGroup>
//                       </Dropdown>
//                     </Col>
//                   </Row>

//                   {/* Booking Table */}
//                   <Row>
//                     <Col>
//                       <Table responsive striped bordered hover>
//                         <thead>
//                           <tr>
//                             <th>S.No</th>
//                             <th>Mobile Number</th>
//                             <th>Customer Name</th>
//                             <th>Gothram</th>
//                             <th>Amount</th>
//                             <th>Pooja Name</th>
//                             <th>Pooja Date</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {currentBookings.map((row, index) => (
//                             <tr key={row.sno}>
//                               <td>{indexOfFirstBooking + (index + 1)}</td>
//                               <td>{row.mobileNumber}</td>
//                               <td>{row.customerName}</td>
//                               <td>{row.gothram}</td>
//                               <td>{row.amount}</td>
//                               <td>{row.poojaname}</td>
//                               <td>{formatDate(row.poojadate)}</td>
//                             </tr>
//                           ))}
//                         </tbody>
//                       </Table>

//                       {/* Pagination */}
//                       <Pagination>
//                         <Pagination.Prev
//                           onClick={() => handlePageChange(currentPage - 1)}
//                           disabled={currentPage === 1}
//                         />

//                         {/* Conditionally render pagination items */}
//                         {getPaginationGroup().map((number) => (
//                           <Pagination.Item
//                             key={number}
//                             active={number === currentPage}
//                             onClick={() => handlePageChange(number)}
//                           >
//                             {number}
//                           </Pagination.Item>
//                         ))}

//                         {/* Ellipsis if there are more pages to skip */}
//                         {totalPages > 5 && currentPage < totalPages - 1 && (
//                           <Pagination.Ellipsis />
//                         )}

//                         <Pagination.Next
//                           onClick={() => handlePageChange(currentPage + 1)}
//                           disabled={currentPage === totalPages}
//                         />
//                       </Pagination>
//                     </Col>
//                   </Row>
//                 </Container>
//               </Card.Body>
           
//           </section>
//         </div>
//       </div>
//     </>
//   );
// };

// export default ViewBooking;



import React, { useState, useEffect, useMemo } from 'react';
import axios from 'axios';
import Sidebar from '../Sidebar/Sidebar';

// Self-contained SVG Icons
const Icons = {
  Search: (size = 16) => (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <circle cx="11" cy="11" r="8"></circle>
      <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
    </svg>
  )
};

const ViewBooking = () => {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [selectedPooja, setSelectedPooja] = useState("All Poojas");
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fetch booking data from the Express backend
  useEffect(() => {
    setLoading(true);
    axios.get('https://posapi.emedha.in/api/api/bookings')
      .then(response => {
        setBookings(response.data || []);
      })
      .catch(error => {
        console.error('There was an error fetching the bookings:', error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  // Format date as YYYY-MM-DD
  const formatDate = (dateString) => {
    if (!dateString) return '—';
    const date = new Date(dateString);
    if (isNaN(date.getTime())) return dateString;
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  // Distinct pooja names for dropdown filter
  const poojaOptions = useMemo(() => {
    const names = bookings.map(b => b.poojaname).filter(Boolean);
    return ["All Poojas", ...Array.from(new Set(names))];
  }, [bookings]);

  // Filtered bookings
  const filteredBookings = useMemo(() => {
    return bookings.filter((b) => {
      const q = searchQuery.toLowerCase();
      const matchesSearch =
        (b.customerName && b.customerName.toLowerCase().includes(q)) ||
        (b.mobileNumber && b.mobileNumber.toLowerCase().includes(q)) ||
        (b.gothram && b.gothram.toLowerCase().includes(q)) ||
        (b.poojaname && b.poojaname.toLowerCase().includes(q));

      const matchesPooja =
        selectedPooja === "All Poojas" || b.poojaname === selectedPooja;

      return matchesSearch && matchesPooja;
    });
  }, [bookings, searchQuery, selectedPooja]);

  // Summary Metrics
  const totalRevenue = useMemo(() => {
    return filteredBookings.reduce((sum, b) => sum + (Number(b.amount) || 0), 0);
  }, [filteredBookings]);

  const uniquePoojasCount = useMemo(() => {
    return new Set(filteredBookings.map((b) => b.poojaname).filter(Boolean)).size;
  }, [filteredBookings]);

  // Pagination calculation
  const totalPages = Math.ceil(filteredBookings.length / pageSize) || 1;
  const indexOfFirstBooking = (currentPage - 1) * pageSize;
  const currentBookings = filteredBookings.slice(
    indexOfFirstBooking,
    indexOfFirstBooking + pageSize
  );

  const handlePageSizeChange = (newSize) => {
    setPageSize(newSize);
    setCurrentPage(1);
  };

  const getPaginationItems = () => {
    if (totalPages <= 8) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
    if (currentPage <= 4) {
      return [1, 2, 3, 4, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    if (currentPage >= totalPages - 3) {
      return [1, 2, 3, 4, "...", totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
    }
    return [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
  };

  return (
    <div 
    //style={{ display: 'flex', minHeight: '100vh', backgroundColor: '#fcfaf8' }}
    >
      <Sidebar />

      <div
        // id="main"
        // style={{
        //   flex: 1,
        //   display: 'flex',
        //   flexDirection: 'column',
        //   minWidth: 0,
        //   fontFamily: "system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
        // }}
      >
        <div
          style={{
            padding: isMobile ? '16px' : '28px',
            maxWidth: '1280px',
            width: '100%',
            margin: '0 auto',
            boxSizing: 'border-box',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          {/* Header */}
          <div
            style={{
              display: 'flex',
              flexDirection: isMobile ? 'column' : 'row',
              alignItems: isMobile ? 'flex-start' : 'center',
              justifyContent: 'space-between',
              gap: '16px',
              width: '100%'
            }}
          >
            <div>
              <h2
                style={{
                  margin: 0,
                  fontSize: isMobile ? '22px' : '26px',
                  fontWeight: '700',
                  color: '#111827',
                  fontFamily: "'Cinzel', serif"
                }}
              >
                View Bookings
              </h2>
              <p style={{ margin: '4px 0 0 0', fontSize: '14px', color: '#6b7280' }}>
                Track devotee bookings, gothrams, poojas, and contributions
              </p>
            </div>
          </div>

          {/* Summary KPIs */}
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
              gap: '16px',
              width: '100%'
            }}
          >
            <div
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                border: '1px solid #ffedd5',
                padding: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
              }}
            >
              <p style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#ea580c' }}>
                {filteredBookings.length}
              </p>
              <p style={{ margin: '4px 0 0 0', fontSize: '12px', fontWeight: '600', color: '#374151' }}>
                Total Bookings
              </p>
              <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af' }}>
                matching current view
              </p>
            </div>

            <div
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                border: '1px solid #ffedd5',
                padding: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
              }}
            >
              <p style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#16a34a' }}>
                ₹{totalRevenue.toLocaleString()}
              </p>
              <p style={{ margin: '4px 0 0 0', fontSize: '12px', fontWeight: '600', color: '#374151' }}>
                Total Collection
              </p>
              <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af' }}>
                sum of booking amounts
              </p>
            </div>

            <div
              style={{
                backgroundColor: '#ffffff',
                borderRadius: '16px',
                border: '1px solid #ffedd5',
                padding: '20px',
                boxShadow: '0 1px 3px rgba(0,0,0,0.05)'
              }}
            >
              <p style={{ margin: 0, fontSize: '24px', fontWeight: '700', color: '#4f46e5' }}>
                {uniquePoojasCount}
              </p>
              <p style={{ margin: '4px 0 0 0', fontSize: '12px', fontWeight: '600', color: '#374151' }}>
                Unique Poojas
              </p>
              <p style={{ margin: 0, fontSize: '12px', color: '#9ca3af' }}>
                distinct pooja services
              </p>
            </div>
          </div>

          {/* Main Table Container */}
          <div
            style={{
              backgroundColor: '#ffffff',
              borderRadius: '16px',
              border: '1px solid #ffedd5',
              boxShadow: '0 1px 3px rgba(0,0,0,0.05)',
              width: '100%',
              overflow: 'hidden'
            }}
          >
            {/* Filters Toolbar */}
            <div
              style={{
                padding: '16px 20px',
                borderBottom: '1px solid #ffedd5',
                display: 'flex',
                flexDirection: isMobile ? 'column' : 'row',
                justifyContent: 'space-between',
                alignItems: isMobile ? 'stretch' : 'center',
                gap: '12px',
                backgroundColor: '#ffffff'
              }}
            >
              <div style={{ position: 'relative', flex: 1, maxWidth: isMobile ? '100%' : '420px' }}>
                <span
                  style={{
                    position: 'absolute',
                    left: '14px',
                    top: '50%',
                    transform: 'translateY(-50%)',
                    color: '#9ca3af',
                    display: 'flex',
                    alignItems: 'center'
                  }}
                >
                  {Icons.Search(16)}
                </span>
                <input
                  placeholder="Search by Name, Mobile, Gothram, or Pooja..."
                  value={searchQuery}
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                    setCurrentPage(1);
                  }}
                  style={{
                    width: '100%',
                    padding: '11px 16px 11px 40px',
                    borderRadius: '12px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    boxSizing: 'border-box'
                  }}
                />
              </div>

              <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
                <select
                  value={selectedPooja}
                  onChange={(e) => {
                    setSelectedPooja(e.target.value);
                    setCurrentPage(1);
                  }}
                  style={{
                    padding: '9px 14px',
                    borderRadius: '10px',
                    border: '1px solid #e5e7eb',
                    fontSize: '14px',
                    outline: 'none',
                    backgroundColor: '#fdf8f3',
                    color: '#1f2937',
                    cursor: 'pointer'
                  }}
                >
                  {poojaOptions.map((option, idx) => (
                    <option key={idx} value={option}>{option}</option>
                  ))}
                </select>

                <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: '#4b5563' }}>
                  <span>Show</span>
                  <select
                    value={pageSize}
                    onChange={(e) => handlePageSizeChange(Number(e.target.value))}
                    style={{
                      padding: '8px 12px',
                      borderRadius: '10px',
                      border: '1px solid #e5e7eb',
                      fontSize: '14px',
                      backgroundColor: '#ffffff',
                      color: '#1f2937',
                      outline: 'none',
                      cursor: 'pointer'
                    }}
                  >
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={30}>30</option>
                  </select>
                  <span>entries</span>
                </div>
              </div>
            </div>

            {/* Table */}
            {loading ? (
              <div style={{ textAlign: 'center', padding: '50px 0', color: '#6b7280', fontSize: '14px' }}>
                Loading bookings...
              </div>
            ) : (
              <div style={{ width: '100%', overflowX: 'auto' }}>
                <table
                  style={{
                    width: '100%',
                    minWidth: '750px',
                    borderCollapse: 'collapse',
                    textAlign: 'left'
                  }}
                >
                  <thead>
                    <tr
                      style={{
                        backgroundColor: 'rgba(255, 247, 237, 0.6)',
                        borderBottom: '1px solid #ffedd5',
                        fontSize: '12px',
                        fontWeight: '600',
                        color: '#374151',
                        textTransform: 'uppercase',
                        letterSpacing: '0.05em'
                      }}
                    >
                      <th style={{ padding: '14px 20px', width: '70px' }}>S.No</th>
                      <th style={{ padding: '14px 20px' }}>Mobile Number</th>
                      <th style={{ padding: '14px 20px' }}>Customer Name</th>
                      <th style={{ padding: '14px 20px' }}>Gothram</th>
                      <th style={{ padding: '14px 20px' }}>Amount</th>
                      <th style={{ padding: '14px 20px' }}>Pooja Name</th>
                      <th style={{ padding: '14px 20px' }}>Pooja Date</th>
                    </tr>
                  </thead>
                  <tbody style={{ fontSize: '14px' }}>
                    {currentBookings.length > 0 ? (
                      currentBookings.map((row, index) => {
                        const serialNumber = indexOfFirstBooking + index + 1;
                        return (
                          <tr
                            key={row.sno || index}
                            style={{
                              borderBottom: '1px solid #fff7ed',
                              backgroundColor: '#ffffff'
                            }}
                          >
                            <td style={{ padding: '16px 20px', color: '#6b7280', fontWeight: '500', fontSize: '13px' }}>
                              {serialNumber}
                            </td>
                            <td style={{ padding: '16px 20px', fontFamily: 'monospace', fontSize: '13px', color: '#4b5563' }}>
                              {row.mobileNumber}
                            </td>
                            <td style={{ padding: '16px 20px', fontWeight: '600', color: '#111827' }}>
                              {row.customerName}
                            </td>
                            <td style={{ padding: '16px 20px' }}>
                              <span
                                style={{
                                  display: 'inline-block',
                                  padding: '4px 10px',
                                  borderRadius: '9999px',
                                  fontSize: '12px',
                                  fontWeight: '500',
                                  backgroundColor: '#fff7ed',
                                  color: '#c2410c',
                                  border: '1px solid #ffedd5'
                                }}
                              >
                                {row.gothram || '—'}
                              </span>
                            </td>
                            <td style={{ padding: '16px 20px', fontWeight: '700', color: '#111827' }}>
                              ₹{Number(row.amount || 0).toLocaleString()}
                            </td>
                            <td style={{ padding: '16px 20px', fontWeight: '500', color: '#1f2937' }}>
                              {row.poojaname}
                            </td>
                            <td style={{ padding: '16px 20px', color: '#6b7280', fontSize: '13px' }}>
                              {formatDate(row.poojadate)}
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td
                          colSpan={7}
                          style={{
                            textAlign: 'center',
                            padding: '40px 0',
                            color: '#9ca3af',
                            fontSize: '14px'
                          }}
                        >
                          No bookings found matching your filter criteria.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* Pagination Controls */}
            {totalPages > 1 && (
              <div
                style={{
                  display: 'flex',
                  flexDirection: isMobile ? 'column' : 'row',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  gap: '12px',
                  padding: '16px 20px',
                  borderTop: '1px solid #ffedd5',
                  backgroundColor: '#ffffff',
                  flexWrap: 'wrap'
                }}
              >
                <p style={{ margin: 0, fontSize: '13px', color: '#6b7280' }}>
                  Showing {indexOfFirstBooking + 1} to{' '}
                  {Math.min(indexOfFirstBooking + pageSize, filteredBookings.length)} of {filteredBookings.length} entries
                </p>

                <div style={{ display: 'flex', alignItems: 'center', gap: '4px', flexWrap: 'wrap' }}>
                  {/* First Page */}
                  <button
                    onClick={() => setCurrentPage(1)}
                    disabled={currentPage === 1}
                    style={{
                      padding: '6px 10px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                      opacity: currentPage === 1 ? 0.4 : 1
                    }}
                  >
                    « First
                  </button>

                  {/* Previous */}
                  <button
                    onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                    disabled={currentPage === 1}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === 1 ? 'not-allowed' : 'pointer',
                      opacity: currentPage === 1 ? 0.4 : 1
                    }}
                  >
                    Prev
                  </button>

                  {/* Page Numbers & Ellipsis */}
                  {getPaginationItems().map((item, index) => {
                    if (item === "...") {
                      return (
                        <span
                          key={`ellipsis-${index}`}
                          style={{
                            display: 'inline-flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '28px',
                            height: '32px',
                            fontSize: '14px',
                            color: '#9ca3af',
                            userSelect: 'none'
                          }}
                        >
                          ...
                        </span>
                      );
                    }

                    const isCurrent = currentPage === item;
                    return (
                      <button
                        key={`page-${item}`}
                        onClick={() => setCurrentPage(item)}
                        style={{
                          minWidth: '32px',
                          height: '32px',
                          padding: '0 6px',
                          borderRadius: '8px',
                          fontSize: '12px',
                          fontWeight: isCurrent ? '700' : '500',
                          cursor: 'pointer',
                          border: isCurrent ? 'none' : '1px solid #e5e7eb',
                          backgroundColor: isCurrent ? '#f97316' : '#ffffff',
                          color: isCurrent ? '#ffffff' : '#4b5563',
                          boxShadow: isCurrent ? '0 2px 8px rgba(249, 115, 22, 0.3)' : 'none'
                        }}
                      >
                        {item}
                      </button>
                    );
                  })}

                  {/* Next */}
                  <button
                    onClick={() => setCurrentPage((p) => Math.min(p + 1, totalPages))}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: '6px 12px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                      opacity: currentPage === totalPages ? 0.4 : 1
                    }}
                  >
                    Next
                  </button>

                  {/* Last Page */}
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    disabled={currentPage === totalPages}
                    style={{
                      padding: '6px 10px',
                      borderRadius: '8px',
                      border: '1px solid #e5e7eb',
                      fontSize: '12px',
                      fontWeight: '500',
                      color: '#4b5563',
                      backgroundColor: '#ffffff',
                      cursor: currentPage === totalPages ? 'not-allowed' : 'pointer',
                      opacity: currentPage === totalPages ? 0.4 : 1
                    }}
                  >
                    Last »
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewBooking;